export interface Testimonial {
  initials: string
  name: string
  role: string
  text: string
}

export const shortTestimonials: Testimonial[] = [
  {
    initials: 'SM',
    name: 'S.M.',
    role: "Professeure d'espagnol — Lyon, France",
    text: "Je ne passe plus mes dimanches soir à construire des cours de zéro. J'ouvre le système, je choisis la leçon et j'entre en classe complètement préparé. Mes élèves sentent la différence — et moi aussi.",
  },
  {
    initials: 'CV',
    name: 'C.V.',
    role: "Professeur d'espagnol — Bruxelles, Belgique",
    text: "Les cours d'urgence m'ont sauvée trois fois rien que le premier mois. Ce bonus vaut à lui seul le prix total du système.",
  },
  {
    initials: 'JR',
    name: 'J.R.',
    role: "Professeure d'espagnol — Montréal, Québec",
    text: "Le guide grammatical a changé ma façon d'expliquer les concepts. Mes explications sont plus claires, mes élèves comprennent plus vite et je ne perds plus de temps à chercher des exemples.",
  },
]

export const extendedTestimonials: Testimonial[] = [
  {
    initials: 'VT',
    name: 'V.T.',
    role: "Professeure d'espagnol, Paris, France",
    text: "La progression lente des leçons a complètement changé la façon dont mes élèves vivent la grammaire. Tout est déjà écrit — je n'ai plus qu'à l'enseigner. Mes cours se sentent plus professionnels que jamais.",
  },
  {
    initials: 'CR',
    name: 'C.R.',
    role: "Professeur d'espagnol, Genève, Suisse",
    text: "Les cours d'urgence m'ont sauvée plus de fois que je ne peux compter. Avant ça, je paniquais quand mon plan tombait à l'eau. Maintenant j'ouvre juste le fichier de secours et j'enseigne.",
  },
  {
    initials: 'DG',
    name: 'D.G.',
    role: "Professeure d'espagnol, Montréal, Québec",
    text: "Je relis le point grammatical avant chaque leçon et j'entre en sachant exactement quoi dire et comment le dire. Les notes d'orientation pour le professeur, je les utilise chaque semaine.",
  },
  {
    initials: 'AM',
    name: 'A.M.',
    role: "Professeur d'espagnol, Bruxelles, Belgique",
    text: "Le pack d'évaluations m'a rendu mes soirées. Je passais des heures à écrire des examens et créer des corrigés. Maintenant j'ouvre le fichier et c'est terminé en cinq minutes.",
  },
  {
    initials: 'SR',
    name: 'S.R.',
    role: "Professeure d'espagnol, Casablanca, Maroc",
    text: "Les leçons de culture ont été une révélation totale. Mes élèves parlent encore de ces cours des semaines plus tard. Ça se sent comme une vraie expérience — pas juste une fiche de lecture.",
  },
]
